import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AdminAreaRequest } from 'src/app/models/area.model';
import { LocationResponse } from 'src/app/models/location.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-admin-area',
  templateUrl: './modal-admin-area.component.html',
  styleUrls: ['./modal-admin-area.component.scss']
})
export class ModalAdminAreaComponent implements OnInit {
  @Input() isCreating: boolean = true;
  @Input() newArea: AdminAreaRequest = new AdminAreaRequest();
  @Input() warehouses: LocationResponse[] = [];
  loading = false;
  @Output() close = new EventEmitter<boolean>();
  nameLocation = "";
  addressLocation = "";

  constructor(
    private rrhhService: HumanResourcesService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {

  }

  createOrEdit() {
    if (this.isCreating){
      this.loading = true;
      this.rrhhService.createArea(this.newArea).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Area creada exitosamente");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.loading = true;
      this.rrhhService.updateArea(this.newArea['id'],this.newArea).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Area editada exitosamente");
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    }

  }
}
